import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { HAS_INCLUDES_PRODUCTS, IS_VARIANT_PRODUCT } from "@thkStore/Constants/ProductPropertiesKeys";
import { ApplicationIncludeProductsState } from "@thkStore/Store/Widgets/IncludeProducts/IncludeProductsReducer";

/**
 * A product is a "variant with includes" when it is a variant child that also has related
 * (included/kit) products. The ClipboardSummary and the Include Products checkbox both key
 * their behavior off this flag.
 */
export function getIsVariantWithIncludes(product: ProductModel | undefined) {
    return (
        !!product &&
        product.properties?.[IS_VARIANT_PRODUCT] === "True" &&
        product.properties?.[HAS_INCLUDES_PRODUCTS] === "true"
    );
}

/**
 * Whether the Include Products checkbox is currently checked for the given product. The flag is
 * stored alongside the product id it belongs to, so a different product reads as unchecked — this
 * resets the toggle on navigation (mirroring the clipboard's parentProductId guard).
 */
export function getIsIncludeProductsChecked(state: ApplicationState, productId: string | undefined) {
    const includeProducts = (state as ApplicationIncludeProductsState).includeProducts;
    return !!productId && includeProducts?.productId === productId && !!includeProducts?.checked;
}
